import * as React from "react";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el locale español
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { DayCalendarSkeleton } from "@mui/x-date-pickers/DayCalendarSkeleton";
import { Badge, Button, IconButton, Typography } from "@mui/joy";
import { Box } from "@mui/material";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

// Configura dayjs para usar el locale español
dayjs.locale("es");

//* Componente personalizado para renderizar los días
function CustomDay(props) {
  const { day, outsideCurrentMonth, highlightedDates, ...other } = props;

  const turno = highlightedDates.find((turno) => dayjs(turno.date).isSame(day, "day"));

  return (
    <Badge
      key={day.toString()}
      variant="solid"
      color="primary"
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      badgeContent={turno ? (turno.cantTurnos > 9 ? "+9" : "" + turno.cantTurnos) : undefined}
      sx={{
        fontSize: "8px",
        "& .MuiBadge-badge": { backgroundColor: "#8c55da" },
      }}
      size="md"
      badgeInset="10%"
      invisible={!turno}
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        sx={{
          ...(turno && {
            color: turno?.textColor,
            backgroundColor: turno?.backgroundColor,
          }),
          borderRadius: "4px",
          fontSize: "18px",
          "& .MuiBadge-badge": { backgroundColor: turno?.backgroundColor },
        }}
        disabled={!turno}
      />
    </Badge>
  );
}

export default function CustomCalendar({ value, onChange, minDate, maxDate, highlightedDates }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DateCalendar
          value={dayjs(value)}
          onChange={onChange}
          renderLoading={() => <DayCalendarSkeleton />}
          slots={{
            day: CustomDay,
          }}
          slotProps={{
            day: {
              highlightedDates,
            },
          }}
          showDaysOutsideCurrentMonth
          minDate={minDate}
          maxDate={maxDate}
          disablePast
          dayOfWeekFormatter={(weekday) => (
            <Button disabled variant={"plain"} sx={{}}>
              <Typography
                sx={{
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                {weekday.format("dd")}
              </Typography>
            </Button>
          )}
        />
      </Box>
    </LocalizationProvider>
  );
}
